var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/static/new/img/login/login_logo.webp"),"alt":""}})])])
}]

export { render, staticRenderFns }